import { Cr } from './Cr';

export class AbrirChamadoDTO {
    cr: Cr;
    email: string;
    sistema: string;
    codigoCNSArecadacao : string;
    codigoFlag : string;
    nomeDelegatario : string;
    sistemaUsuarioInt : string;
    grupo : string;
    solicitacoes = new Array<String>();
    solicitacoesCoarc = new Array<String>();

    constructor()
    constructor() {
        this.cr = new Cr(); 
    }
}
